import { render, staticRenderFns } from "./row-flag.vue?vue&type=template&id=95d6e4e4&scoped=true&"
import script from "./row-flag.vue?vue&type=script&lang=js&"
export * from "./row-flag.vue?vue&type=script&lang=js&"
import style0 from "./row-flag.vue?vue&type=style&index=0&id=95d6e4e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d6e4e4",
  null
  
)

export default component.exports